import React, { Component } from 'react';
import facebook from "../../../assets/social_media_icons/facebook.svg";
import tiktok from "../../../assets/social_media_icons/tiktok.svg";
import linkedin from "../../../assets/social_media_icons/linkedin.svg";
import wechat from "../../../assets/social_media_icons/wechat.svg";
import {ReactComponent as TwitterLogo} from "../../../assets/social_media_icons/twitter.svg";
import youtube from "../../../assets/social_media_icons/youtube.svg";
import instagram from "../../../assets/social_media_icons/instagram.svg";
import clubhouse from "../../../assets/social_media_icons/clubhouse.svg";
import podcast from "../../../assets/social_media_icons/podcast.svg";
import "./home_page_desktop_socials.scss";

const SVG_ID = "#svg_id";

class HomePageDesktopSocials extends Component {
    render() {

        return (
            <div className="home-page-socials home-page-overlay">
                <a href="https://podcast.luiss.it/" className="social-link" aria-label="podcast">
                    <svg className="social-icon">
                        <use xlinkHref={`${podcast}${SVG_ID}`} />
                    </svg>
                </a>
                <a href="https://www.facebook.com/uni.luiss" className="social-link" aria-label="Facebook">
                    <svg className="social-icon facebook">
                        <use xlinkHref={`${facebook}${SVG_ID}`} />
                    </svg>
                </a>
                <a href=" https://vm.tiktok.com/4JAtqe/" className="social-link" aria-label="Tiktok">
                    <svg className="social-icon tiktok">
                        <use xlinkHref={`${tiktok}${SVG_ID}`} />
                    </svg>
                </a>
                <a href="https://www.linkedin.com/school/luiss-guido-carli-university/" className="social-link" aria-label="LinkedIn">
                    <svg className="social-icon whatsapp">
                        <use xlinkHref={`${linkedin}${SVG_ID}`} />
                    </svg>
                </a>
                <a href="https://weixin.qq.com/r/rRxQSBrECEd3rV4r90m-" className="social-link" aria-label="WeChat">
                    <svg className="social-icon wechat">
                        <use xlinkHref={`${wechat}${SVG_ID}`} />
                    </svg>
                </a>
                <a href="https://twitter.com/uniLUISS" className="social-link" aria-label="Twitter">
                    <TwitterLogo/>
                    {/* <svg className="social-icon twitter">
                        <use xlinkHref={`${twitter}${SVG_ID}`} />
                    </svg> */}
                </a>
                <a href="https://www.youtube.com/user/LUISSGuidoCarli" className="social-link" aria-label="Youtube">
                    <svg className="social-icon youtube">
                        <use xlinkHref={`${youtube}${SVG_ID}`} />
                    </svg>
                </a>
                <a href="https://www.instagram.com/uniluiss/" className="social-link" aria-label="Instagram">
                    <svg className="social-icon instagram">
                        <use xlinkHref={`${instagram}${SVG_ID}`} />
                    </svg>
                </a>
                <a href="https://www.joinclubhouse.com/club/luiss-university" className="social-link" aria-label="Clubhouse">
                    <svg className="social-icon clubhouse">
                        <use xlinkHref={`${clubhouse}${SVG_ID}`} />
                    </svg>
                </a>
            </div>
        );
    }
}

export default HomePageDesktopSocials;
